import legacyOpenCityList from './cityData.js.js';

const CITY_DATA_URL = '/static/cities.json';
const CITY_LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

const legacyCityMap = legacyOpenCityList.reduce((cityMap, group) => {
  group[1].forEach(city => {
    cityMap[city.name] = city;
  });
  return cityMap;
}, {});

function createEmptyCityList () {
  return CITY_LETTERS.map(letter => [letter, []]);
}

function getAllCities (data) {
  if (data && data.data && Array.isArray(data.data.allCities)) {
    return data.data.allCities;
  }

  if (data && Array.isArray(data.allCities)) {
    return data.allCities;
  }

  return [];
}

function getFirstChar (city) {
  const parentMeta = getLegacyCityMeta(city.cityNameZh);
  const firstChar = String(parentMeta.firstChar || city.abbr || city.cityNameEn || '').charAt(0).toUpperCase();
  return CITY_LETTERS.indexOf(firstChar) > -1 ? firstChar : '';
}

function stripAdministrativeSuffix (name) {
  return String(name || '').replace(/(自治州|地区|盟|市|县|区)$/g, '');
}

function getLegacyCityMeta (name) {
  const cityName = String(name || '');
  return legacyCityMap[cityName] || legacyCityMap[stripAdministrativeSuffix(cityName)] || {};
}

function toCityOption (city, firstChar) {
  const parentMeta = getLegacyCityMeta(city.cityNameZh);
  const districtMeta = getLegacyCityMeta(city.districtName);
  const cityName = city.districtName ? `${city.districtName}(${city.cityNameZh})` : city.cityNameZh;
  const cityCode = city.districtName ? `${city.gbCityCode}${city.districtCode}` : city.gbCityCode;

  return {
    id: cityCode,
    name: cityName,
    gbCityCode: city.gbCityCode,
    cityName: city.cityNameZh,
    districtName: city.districtName || '',
    districtCode: city.districtCode || '',
    pinyin: String(city.cityNameEn || parentMeta.pinyin || '').toLowerCase(),
    acronym: String(city.abbr || parentMeta.acronym || '').toLowerCase(),
    cityPinyin: String(city.cityNameEn || parentMeta.pinyin || '').toLowerCase(),
    cityAcronym: String(city.abbr || parentMeta.acronym || '').toLowerCase(),
    districtPinyin: String(districtMeta.pinyin || '').toLowerCase(),
    districtAcronym: String(districtMeta.acronym || '').toLowerCase(),
    rank: city.cityCode || '',
    firstChar,
    latitude: city.latitude,
    longitude: city.longitude
  };
}

export function transformToOpenCityList (data) {
  const openCityList = createEmptyCityList();

  getAllCities(data).forEach(city => {
    const firstChar = getFirstChar(city);
    const cityName = city && city.cityNameZh;
    const gbCityCode = city && city.gbCityCode;

    if (!firstChar || !cityName || !gbCityCode) {
      return;
    }

    const index = openCityList.findIndex(item => item[0] === firstChar);
    openCityList[index][1].push(toCityOption(city, firstChar));
  });

  return openCityList;
}

export function loadOpenCityList () {
  return fetch(CITY_DATA_URL, {cache: 'no-cache'})
    .then(response => {
      if (!response.ok) {
        throw new Error('城市列表加载失败');
      }
      return response.json();
    })
    .then(data => transformToOpenCityList(data));
}
